<!-- =========================================================================================
    File Name: ItemListView.vue
    Description: Item Component - List VIew
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
<div>
  Manage
</div>
</template>


<script>

export default {
  components: {
  },
  data() {
    return {
    }
  },
  watch: {

  },
  computed: {

  },
  methods: {

  },
  mounted() {
  }
}

</script>
